import { useState } from 'react';
import { useTranslation } from '../i18n/LanguageContext.jsx';
import { API_URL } from '../config/api.js';
import './PasswordGate.css';

/**
 * PasswordGate component — renders a password form that verifies
 * against POST /api/interview/verify. On success, calls onSuccess(token).
 *
 * @param {Object} props
 * @param {function} props.onSuccess - Called with the auth token on successful verification
 */
function PasswordGate({ onSuccess }) {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();

    if (!password.trim()) {
      return;
    }

    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/interview/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });

      if (response.ok) {
        const data = await response.json();
        onSuccess(data.token);
      } else if (response.status === 401) {
        setError(t('interview.error'));
      } else {
        setError(t('interview.genericError'));
      }
    } catch {
      setError(t('interview.genericError'));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="password-gate">
      <h1>{t('interview.pageTitle')}</h1>
      <form onSubmit={handleSubmit} className="password-gate__form">
        <label htmlFor="interview-password">{t('interview.passwordLabel')}</label>
        <input
          id="interview-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={t('interview.passwordPlaceholder')}
          disabled={loading}
          autoComplete="off"
        />
        <button type="submit" disabled={loading}>
          {loading ? t('interview.loading') : t('interview.submit')}
        </button>
        {error && (
          <p className="password-gate__error" role="alert">
            {error}
          </p>
        )}
      </form>
    </div>
  );
}

export default PasswordGate;
